<template>
  <div class="section" id="carousel">
    <div class="container">
      <div class="title">
        <!-- <h4>Nuestros trabajos nos avalan</h4> -->
      </div>
      <div class="row justify-content-center">
        <div class="col-8">
          <el-carousel height="500px">
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_1.jpg"/>
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_2.jpg"/>
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_3.jpg" alt="Second slide" />
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_4.jpg" alt="Third slide" />
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_5.jpg" alt="Third slide" />
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/carrucel_6.jpg" alt="Third slide" />
              <div class="carousel-caption d-none d-md-block">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  }
};
</script>
<style></style>
